import { useCloudFunction } from './useCloudFunction';
import { dateToNs, nsToDate } from './timestampUtils';
import { numericRecord } from './numericRecord';
import type { AccountTrade } from '../types';
import type { RawTradeRow } from './tradeTypes';

export function useCombinedTrades(
  accountIds: string[],
  from: Date,
  to: Date,
  offset = 0,
): { data: AccountTrade[]; loading: boolean; error: Error | null } {
  const params =
    accountIds.length > 0
      ? { accountIds, from: dateToNs(from), to: dateToNs(to), offset }
      : null;

  return useCloudFunction<RawTradeRow, AccountTrade>(
    'loadAccountTrades',
    params,
    (rows) =>
      rows.map((row) => ({
        transaction_id: row.transaction_id,
        account_id: row.account_id,
        status: row.status as AccountTrade['status'],
        liquidity_source: row.liquidity_source,
        trade: {
          side: row.side as AccountTrade['trade']['side'],
          base_asset: row.base_asset,
          quote_asset: row.quote_asset,
          base_amount: Number(row.base_amount),
          quote_amount: Number(row.quote_amount),
          price: Number(row.price),
          base_valuation: row.base_valuation,
          quote_valuation: row.quote_valuation,
        },
        swap: {
          direction: row.direction as AccountTrade['swap']['direction'],
          buy_asset: row.buy_asset,
          sell_asset: row.sell_asset,
          buy_amount: Number(row.buy_amount),
          sell_amount: Number(row.sell_amount),
          rate: Number(row.rate),
          buy_valuation: row.buy_valuation,
          sell_valuation: row.sell_valuation,
        },
        cost: numericRecord(row.cost ?? {}),
        cost_valuation: row.cost_valuation,
        meta_data: row.meta_data,
        timestamp: nsToDate(row.timestamp),
      })),
  );
}
